document.querySelectorAll('.acc-header').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    item.classList.toggle('open');
  });
});

// 送料・注文後アナウンスを GPO クローン「カートに追加する」ボタンの直前へ移動
// （Globo Product Options が動的に挿入するクローンボタンに追従させるため）
document.addEventListener('DOMContentLoaded', function () {
  const note = document.querySelector('.product__cart-note');
  if (!note) return;

  const moveNote = () => {
    const gpoBtn = document.querySelector('.gpo-clone-atc-button');
    if (!gpoBtn) return;
    // 既に直前に配置済みなら何もしない（重複処理防止）
    if (note.nextElementSibling === gpoBtn) return;
    gpoBtn.parentNode.insertBefore(note, gpoBtn);
  };

  // 初回試行（既に挿入済みなら即移動）
  moveNote();

  // GPO ボタンは遅延注入・再生成されうるため監視を継続
  const observer = new MutationObserver(moveNote);
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', function() {
  const footer = document.querySelector('.sticky-footer');
  const buttons = document.querySelectorAll('.footer-btn');
  let lastScrollPosition = 0;
  const SCROLL_THRESHOLD = 1200;
  
  buttons.forEach(button => {
    const url = button.dataset.url;
    if (url) {
      button.href = url;
      
      // ページ内リンクの場合のスムーズスクロール処理
      if (url.startsWith('#')) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const targetElement = document.querySelector(url);
          if (targetElement) {
            // スクロール位置の調整（固定ヘッダーがある場合は、その高さを考慮）
            const headerOffset = 160; // 固定ヘッダーがある場合は、その高さをピクセルで指定
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }
        });
      }
    }
    
    // LINEボタンの場合は新規タブで開く
    if (button.classList.contains('line-btn')) {
      button.target = '_blank';
      button.rel = 'noopener noreferrer';
    }
  });

  // スクロール表示制御
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > SCROLL_THRESHOLD) {
      footer.classList.add('visible');
    } else {
      footer.classList.remove('visible');
    }

    lastScrollPosition = currentScroll;
  });
});
